import { ProductTagListPage } from '@/features/product-tag/pages/ProductTagListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-tag/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_tag.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductTagListPage,
})
